const $$splitComponentImporter = () => import('/app/apps/web/src/routes/_authenticated-user/oppdrag/$tluxCaseId/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { routeLoaderApiClient } from "@/lib/api";
import { createFileRoute } from "@tanstack/react-router";
export const Route = createFileRoute("/_authenticated-user/oppdrag/$tluxCaseId/")({
  loader: async ({
    params
  }) => {
    const {
      tluxCaseId
    } = params;
    const res = await routeLoaderApiClient.oppdrag[":tluxCaseId"].$get({
      param: {
        tluxCaseId
      }
    });
    if (res.ok === false) {
      throw new Error("Failed to fetch oppdrag");
    }
    return {
      oppdrag: await res.json()
    };
  },
  head: ({
    loaderData
  }) => {
    if (loaderData == null) {
      return {};
    }
    const {
      oppdrag
    } = loaderData;
    return {
      meta: [{
        title: `Oppdrag ${oppdrag.oppdragsnummer} | Alice & Bob`
      }]
    };
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});